import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';

import PropTypes from 'prop-types';

import InspectorDetails from '@/components/InspectorsPage/InspectorDetails';
import InspectorFiltersDetails from '@/components/InspectorsPage/InspectorFiltersDetails';
import { InspectorAppSettingsEdit } from '@/components/InspectorsPage/InspectorAppSettings';
import InspectorForm from '@/components/InspectorsPage/InspectorForm';
import InspectorList from '@/components/InspectorsPage/InspectorList';
import ExportGeneralStatistics from '@/components/InspectorsPage/InspectorList/ExportGeneralStatistics';
import InspectorReport from '@/components/InspectorsPage/InspectorReport';
import Section from '@/components/Page/Section';
import { syncInspectors } from '@/store/ducks/inspectors';

// eslint-disable-next-line no-shadow
const InspectorsPage = ({ syncInspectors }) => {
  useEffect(() => {
    syncInspectors();
  }, [syncInspectors]);

  return (
    <>
      <Section cols={6}>
        <Routes>
          <Route path="/" element={<Navigate to="active" replace />} />
          <Route path="new" element={<InspectorList />} />
          <Route path=":status/*" element={<InspectorList />} />
        </Routes>
      </Section>
      <Section cols={6}>
        <Routes>
          <Route path="new" element={<InspectorForm action="new" />} />
          <Route path="active/:id/edit" element={<InspectorForm action="edit" />} />
          <Route path=":status/:id/report" element={<InspectorReport />} />
          <Route path="active/:id/filters/edit" element={<InspectorFiltersDetails />} />
          <Route path="active/:id/app-settings/edit" element={<InspectorAppSettingsEdit />} />
          <Route path=":status/:id" element={<InspectorDetails />} />
          <Route path=":status" element={<ExportGeneralStatistics />} />
        </Routes>
      </Section>
    </>
  );
};

InspectorsPage.propTypes = {
  syncInspectors: PropTypes.func.isRequired,
};

export default connect(null, { syncInspectors })(InspectorsPage);
